import React from "react";
import { useSelector } from "react-redux";
import { Card } from "components";
import { selectGameObject } from "features/gamestate/gameStateSlice";
import { getDisplayStatus, PUBLISH_STATUS } from "../lifecycle";
import GameHomeHeader from "./GameHomeHeader";
import Hero from "./Hero";
import LiveNowCard from "./LiveNowCard";
import RoundsCard from "./RoundsCard";
import PlayersCard from "./PlayersCard";
import "./GameHome.css";

const GameHome = () => {
  const game = useSelector(selectGameObject);
  if (!game) {
    // Game data is still loading; ManagedGameHome's surrounding shell stays.
    return <div className="gx-gh-loading" aria-busy="true">Loading…</div>;
  }
  const isInProgress = getDisplayStatus(game) === PUBLISH_STATUS.IN_PROGRESS;
  return (
    <div className="gx-gh">
      <GameHomeHeader />
      <section className="gx-gh-hero">
        <Hero />
      </section>
      {isInProgress && (
        <section className="gx-gh-live">
          <LiveNowCard />
        </section>
      )}
      <section className="gx-gh-row-2">
        <Card padding="md" className="gx-gh-card"><RoundsCard /></Card>
        <Card padding="md" className="gx-gh-card"><PlayersCard /></Card>
      </section>
    </div>
  );
};

export default GameHome;
